// Line Entry — the look, from the "Bulk Line Entry UX" canvas (IBM Plex, blue
// accent). Colours ride the app's CSS variables where one exists, with the
// canvas value as the fallback, so a themed app keeps its own accent.

import type { CSSProperties } from 'react'

export const T = {
  accent: 'var(--color-accent, #0061D0)',
  text: 'var(--color-text, #1c2430)',
  muted: 'var(--color-text-secondary, #465062)',
  border: 'var(--color-border, #dde3ea)',
  field: '#c9d2dc',
  bg: 'var(--color-bg, #ffffff)',
  band: 'var(--color-bg-secondary, #f0f3f7)',
  rowAlt: '#f8fafc',
  mono: "'IBM Plex Mono', ui-monospace, SFMono-Regular, Menlo, monospace",
}

/** Status chip tones by the engine's status index: 0 below the bound
 *  (short / early), 1 on it, 2 above it (excess / late); `idle` = not added. */
export const STATUS_TONE: Array<{ bg: string; fg: string }> = [
  { bg: '#fff1e0', fg: '#9a4a00' },
  { bg: '#e6f4ec', fg: '#136c3a' },
  { bg: '#e8f0fe', fg: '#0b4fa8' },
]
export const IDLE_TONE = { bg: '#f0f3f7', fg: '#5b6675' }
export const ERROR_TONE = { bg: '#fde8e8', fg: '#a61b1b' }
export const INFO_BAND = { bg: '#e8f0fe', border: '#b9cff5', fg: '#0b3f86' }

export const btn: CSSProperties = {
  display: 'inline-flex', alignItems: 'center', gap: 6, height: 34, padding: '0 12px',
  borderRadius: 6, border: `1px solid ${T.field}`, background: T.bg, color: T.text,
  fontFamily: 'inherit', fontSize: 14, fontWeight: 500, cursor: 'pointer', whiteSpace: 'nowrap',
  boxSizing: 'border-box',
}
export const btnPri: CSSProperties = {
  ...btn, background: T.accent, borderColor: 'transparent', color: '#fff',
}
export const btnSm: CSSProperties = { ...btn, height: 30, padding: '0 10px', fontSize: 13 }
export const kbd: CSSProperties = {
  fontFamily: T.mono, fontSize: 13, fontWeight: 500, border: `1px solid ${T.field}`,
  borderBottomWidth: 2, borderRadius: 4, padding: '0 5px', color: T.muted, background: T.bg,
}
export const kbdOnPri: CSSProperties = {
  ...kbd, background: 'transparent', color: '#fff', borderColor: 'rgba(255,255,255,.5)',
}
export const chip: CSSProperties = {
  display: 'inline-block', padding: '1px 8px', borderRadius: 9, fontSize: 13, fontWeight: 600,
  whiteSpace: 'nowrap',
}
export const overlay: CSSProperties = {
  position: 'fixed', inset: 0, background: 'rgba(20,28,40,.45)',
  display: 'flex', alignItems: 'flex-start', justifyContent: 'center', padding: '28px 16px',
  overflowY: 'auto',
}
export const dialog: CSSProperties = {
  background: T.bg, color: T.text, borderRadius: 12, width: '100%',
  boxShadow: '0 24px 60px rgba(0,0,0,.25)', display: 'flex', flexDirection: 'column',
  maxHeight: 'calc(100vh - 56px)', overflow: 'hidden', fontSize: 15,
}
export const dialogFoot: CSSProperties = {
  borderTop: `1px solid ${T.border}`, padding: '14px 22px', display: 'flex', alignItems: 'center',
  gap: 12, flexWrap: 'wrap', background: T.band,
}
